import React from "react";
import { cn } from "../../general";

interface ReadOnlyPhoneFieldProps {
  label: string;
  value?: string;
  className?: string;
  countryCode?: string;
  countryFlag?: string;
  showCountrySelector?: boolean;
}

const ReadOnlyPhoneField: React.FC<ReadOnlyPhoneFieldProps> = ({
  label,
  value,
  className,
  countryFlag = "🇸🇦",
  showCountrySelector = true,
}) => {
  const normalizedValue = typeof value === "string" ? value.trim() : value;
  const hasValue =
    normalizedValue !== undefined &&
    normalizedValue !== null &&
    normalizedValue !== "";
  const displayValue = hasValue ? normalizedValue : "-";

  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <span className="text-sm font-medium text-[#414651]">{label}</span>
      <div className="relative">
        <div className="flex rounded-lg border border-[#D5D7DA] bg-gray-50 min-h-[44px]">
          {showCountrySelector && (
            <>
              {/* Country flag section - disabled */}
              <div className="flex items-center border-r border-[#D5D7DA] bg-gray-50 px-3 py-2 rounded-l-lg min-w-[60px]">
                <span className="text-xl">{countryFlag}</span>
                <span className="ml-2">
                  <svg
                    className="w-4 h-4 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </div>
            </>
          )}
          {/* Phone number section */}
          <div
            className={cn(
              "flex items-center px-3.5 py-2 flex-1 text-sm text-[#181D27]",
              !showCountrySelector ? "rounded-lg" : ""
            )}
          >
            <span className="truncate">{displayValue}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyPhoneField;
export type { ReadOnlyPhoneFieldProps };
